export const SECTOR_OPTIONS = [
  { value: '', label: '—' },
  { value: 'manufacturing', label: 'Manufacturing' },
  { value: 'services', label: 'Professional Services' },
  { value: 'technology', label: 'Technology / IT' },
  { value: 'retail', label: 'Retail & E-commerce' },
  { value: 'agriculture', label: 'Agriculture & Food' },
  { value: 'energy', label: 'Energy & Utilities' },
  { value: 'construction', label: 'Construction & Real Estate' },
  { value: 'finance', label: 'Finance & Insurance' },
];

export const REGION_OPTIONS = [
  { value: '', label: '—' },
  { value: 'hu', label: 'Hungary' },
  { value: 'cee', label: 'Central & Eastern Europe' },
  { value: 'dach', label: 'DACH' },
  { value: 'benelux', label: 'Benelux' },
  { value: 'south_eu', label: 'Southern Europe' },
  { value: 'north_eu', label: 'Nordics & Baltics' },
  { value: 'global', label: 'Global' },
];

export const EMPLOYEE_BAND_OPTIONS = [
  { value: '', label: '—' },
  { value: '1-9', label: '1-9' },
  { value: '10-49', label: '10-49' },
  { value: '50-249', label: '50-249' },
  { value: '250-999', label: '250-999' },
  { value: '1000+', label: '1000+' },
];

